<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 20 22">
    <path
      id="icono-directorio"
      d="M20.5,3.5h-1v-2h-2v2h-8v-2h-2v2h-1a2,2,0,0,0-2,2v14a2,2,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2V5.5A2.006,2.006,0,0,0,20.5,3.5Zm-7,3a3,3,0,1,1-3,3A3,3,0,0,1,13.5,6.5Zm6,12H7.5v-1c0-2,4-3.1,6-3.1s6,1.1,6,3.1Z"
      transform="translate(-4.5 -1.5)"
      :fill="colorx"/>
  </svg>
</template>

<script>
export default {
  data: () => ({

  }),
  props: {
    colorx: {
      type: String,
      default: '#89899B'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/DirectoryIcon.vue